import { Component, OnInit } from '@angular/core';
import { MaintenanceMessageService } from '../services/MaintenanceMessage.service';
import { MaintenanceMessageDto } from '../models/MaintenanceMessageDto';
import { SaveStateTypeEnum } from "src/app/shared/Models/enums/SaveStateTypeEnum";
import { ToastService } from "src/app/shared/toast.service";
import { first } from 'rxjs/operators';
import { FormBuilder, FormControl, FormGroup, Validators } from "@angular/forms";
import { Observable } from 'rxjs';

@Component({
  selector: 'app-admin-panel-maintenancemessages',
  templateUrl: './admin-panel-maintenancemessages.component.html',
  styleUrls: ['./admin-panel-maintenancemessages.component.scss']
})
export class AdminPanelMaintenanceMessagesComponent implements OnInit {
  maintenanceMessage: MaintenanceMessageDto = new MaintenanceMessageDto();
  saveState: SaveStateTypeEnum = SaveStateTypeEnum.ongoing;
  maintenanceMessageForm : FormGroup
    

  constructor(
    private maintenanceMessageService: MaintenanceMessageService,
    private toastService: ToastService,
    //private fb: FormBuilder,
  
  ) {}

  ngOnInit(): void {
   this.maintenanceMessageForm = new FormGroup({
        // id: new FormControl(null),
        // message: new FormControl(''),
        // isActive: new FormControl(false),
        messageTitle: new FormControl('', Validators.required),
        messageBody: new FormControl('', Validators.required),
        enabled : new FormControl('', Validators.required),
        urlMoreInfo : new FormControl(''),
        // Add other controls as needed based on MaintenanceMessageDto
      });
      this.getMaintenanceMessage().subscribe(
        data => {
          // Map the API fields to your form controls
          this.maintenanceMessageForm.patchValue({
            messageTitle: data.title,
            messageBody: data.messageBody,
            enabled: data.isActive,
            urlMoreInfo: data.urlMoreInfo !== undefined ? data.urlMoreInfo : '', // Ensure urlMoreInfo is mapped correctly
          });
        },
        error => {
          console.error('Error fetching maintenance message:', error);
          this.showErrorWhileFetchingMaintenanceMessage();
        }
      );
    }


  // Fetch the maintenance message
  private getMaintenanceMessage(): Observable<MaintenanceMessageDto> {
    return this.maintenanceMessageService
      .getmaintenancemessage()
      .pipe(first());
  }

  // Save the maintenance message
  submitMaintenanceMessage(): void {
    this.saveState = SaveStateTypeEnum.ongoing;

    // Get values from the form
    const maintenanceMessage: MaintenanceMessageDto = {
      title: this.maintenanceMessageForm.get('messageTitle')?.value,
      messageBody: this.maintenanceMessageForm.get('messageBody')?.value,
      isActive: this.maintenanceMessageForm.get('enabled')?.value,
      urlMoreInfo: this.maintenanceMessageForm.get('urlMoreInfo')?.value,
      createdAt: new Date() // Add createdAt to satisfy the required property
    };

    this.maintenanceMessageService.addmaintenancemessage(maintenanceMessage).subscribe(
      () => {
        this.saveState = SaveStateTypeEnum.done;
        this.toastService.showSuccesToast(
          $localize`Success`,
          $localize`Maintenance message updated successfully!`
        );
        setTimeout(() => {
          this.saveState = SaveStateTypeEnum.unkown;
        }, 5000);
      },
      () => {
        this.saveState = SaveStateTypeEnum.failed;
        this.showErrorWhileSavingMaintenanceMessage();
      }
    );
  }

  
  // Error handling for fetching the maintenance message
  private showErrorWhileFetchingMaintenanceMessage(): void {
    this.toastService.showErrorToast(
      $localize`Error`,
      $localize`Something went wrong while fetching the maintenance message.`
    );
  }

  // Error handling for saving the maintenance message
  private showErrorWhileSavingMaintenanceMessage(): void {
    this.toastService.showErrorToast(
      $localize`Error`,
      $localize`Something went wrong while saving the maintenance message.`
    );
  }

  // Check if the save state info should be displayed
  canShowStateInfo(): boolean {
    return (
      this.saveState === SaveStateTypeEnum.ongoing ||
      this.saveState === SaveStateTypeEnum.failed ||
      this.saveState === SaveStateTypeEnum.done
    );
  }

  canSubmit(): boolean {
    return (
      this.maintenanceMessageForm.get('messageTitle')?.value &&
      this.maintenanceMessageForm.get('messageBody')?.value &&
      this.maintenanceMessageForm.get('enabled')?.value !== null &&
      this.maintenanceMessageForm.get('enabled')?.value !== undefined &&
      this.maintenanceMessageForm.valid
    );
  }
}